<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q5oHA/tc-custom/9780062249234.jpg?1728851662310" alt="This image is the cover for the book American Ghost"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Ghost
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A haunting story about the long reach of the past.”—Maureen Corrigan, NPR’S <i>Fresh Air</i></b></p><p><b>“In this intriguing book, [Nordhaus] shares her journey to discover who her immigrant ancestor really was—and what strange alchemy made the idea of her linger long after she was gone.” —<i>People</i></b></p><p>La Posada—“place of rest”—was once a grand Santa Fe mansion. It belonged to Abraham and Julia Staab, who emigrated from Germany in the mid-nineteenth century. After they died, the house became a hotel. And in the 1970s, the hotel acquired a resident ghost—a sad, dark-eyed woman in a long gown. Strange things began to happen there: vases moved, glasses flew, blankets were ripped from beds. Julia Staab died in 1896—but her ghost, they say, lives on.</p><p>In <i>American Ghost</i>, Julia’s great-great-granddaughter, Hannah Nordhaus, traces her ancestor’s transfiguration from nineteenth-century Jewish bride to modern phantom. Family diaries, photographs, and newspaper clippings take her on a riveting journey through three hundred years of German history and the American immigrant experience. With the help of historians, genealogists, family members, and ghost hunters, she weaves a masterful, moving story of fin-de-siècle Europe and pioneer life, villains and visionaries, medicine and spiritualism, imagination and truth, exploring how lives become legends, and what those legends tell us about who we are.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hannah Nordhaus
      </h2>
      
      <p class="authorDescription body article"><P>Hannah Nordhaus is the author of the critically acclaimed national bestseller <I>The Beekeeper&#8217;s Lament</I>, which was a PEN Center USA Book Awards finalist, Colorado Book Awards finalist, and National Federation of Press Women Book Award winner. She has written for the <I>Financial Times, Los Angeles Times, Outside magazine, the Times Literary Supplement, Village Voice</I>, and many other publications.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b30ba40